<template>
    <v-card class="elevation-1" >
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Employee :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            <v-chip @click="viewUserProfile(loan_detail, $store.state.userId)" style="margin:-5px 0px 0px -5px;">
                                <v-avatar>
                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(loan_detail.userId)"></v-img>
                                </v-avatar>
                                {{loan_detail.name}} 
                            </v-chip>
                        </v-flex>  
                    </v-layout>
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Loan Type :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            {{loan_detail.loanType}} 
                        </v-flex>  
                    </v-layout>   
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Loan Date :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            {{ loan_detail.loanDate | moment('MMM DD, YYYY') }} 
                        </v-flex>  
                    </v-layout>    
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Principal Amount :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            ₱{{numFormat.formatNumber(loan_detail.principalAmount)}} 
                        </v-flex>  
                    </v-layout> 
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Total Amount to Pay :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            ₱{{numFormat.formatNumber(loan_detail.totalDue)}} 
                        </v-flex>  
                    </v-layout>  
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Monthly Amount to Pay :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                        ₱{{numFormat.formatNumber(loan_detail.monthlyDue)}} 
                        </v-flex>  
                    </v-layout>     
                </v-flex>
                <v-flex xs12 sm6>
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Deduction Type :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            {{ deductionTypes.getDescription(loan_detail.deductionMode) }}
                        </v-flex>  
                    </v-layout>  
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Payment Start Date :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            {{loan_payment_schedule[0].dueOn | moment('MMM DD, YYYY')}}
                        </v-flex>  
                    </v-layout>
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Last Payment Date :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            {{loan_payment_schedule[loan_payment_schedule.length-1].dueOn | moment('MMM DD, YYYY')}}
                        </v-flex>  
                    </v-layout>
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Total Computed :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            ₱{{numFormat.formatNumber(totalComputed)}}
                        </v-flex>  
                    </v-layout>
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            Total Paid :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            ₱{{numFormat.formatNumber(totalPaid)}}
                        </v-flex>  
                    </v-layout>
                    <v-layout row wrap :class="isMobile? 'form-row-mobile' : 'form-row'"> 
                        <v-flex xs5 class="text-xs-left">
                            No. of Payments :
                        </v-flex>
                        <v-flex xs7 class="font-weight-bold text-xs-left">
                            {{totalPayments}}
                        </v-flex>  
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card-text>              
    </v-card>
</template>

<script>

import numFormat from '@/common/num_format'
import commonfn from '@/common/functions'
import awsS3Helper from '@/helpers/aws-s3'
import deductionTypes from '@/helpers/deduction-types'

export default {     
    name: 'LoanDetails',
    metaInfo: {
        title: 'Loan Payment Details',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Loan Payment Details' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    props: ['loan_detail','loan_payment_schedule','viewedByOwner'],
    components: {},   
    data () {
        return {
            deductionTypes,
            numFormat,
            awsS3Helper
        }
    },
    methods: {
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId) this.$router.push(`/myprofile`)
            else this.$router.push(`/hr/employees/${data.userId}`)
        },
    },
    computed: {
        totalComputed() {
            var total = this.loan_payment_schedule
                            .map(x => x.amountDue)
                            .reduce((prev,next)=>prev+next)
            return total
        },
        totalPaid() {
            var total = 0.00
            var paidList = this.loan_payment_schedule.filter(x => {
                return x.status == commonfn.getStatusCode('Paid')
            })
            if (paidList.length > 0)
                total = paidList
                            .map(x => x.amountDue)
                            .reduce((prev,next)=>prev+next)
            
            return total
        },
        totalPayments() {
            return this.loan_payment_schedule.length
        },
    }
}
</script>
<style scoped>
.form-row {
    padding:0px 20px 0px 50px;
}
.form-row-mobile {
    padding:0px 20px 0px 20px;
}
</style>